export default function EventsPage() {
  return (
    <>
      <p>Load the events table here</p>
    </>
  );
}
// TODO: Load the events table
